import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const WarningIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 10"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g clipPath="url(#clip0_21175_183858)">
        <path
          fill="currentColor"
          d="M9.792 7.499 6.26 1.005a1.465 1.465 0 0 0-2.52 0L.208 7.5a1.464 1.464 0 0 0 1.26 2.213h7.065a1.464 1.464 0 0 0 1.26-2.213M5 8.539a.587.587 0 1 1 .002-1.173A.587.587 0 0 1 5 8.54m.586-2.343a.587.587 0 0 1-1.172 0v-2.93a.587.587 0 0 1 1.172 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_21175_183858">
          <path fill="#fff" d="M0 0h10v10H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default WarningIcon;
